// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"fac08c4b","143":"afcf8962","144":"c9d07138","494":"d8177666","533":"d1e3c96e","651":"0536ee1d","690":"f58ecda3","852":"cadd3b4f","940":"20cabea8"}[chunkId] + ".chunk.js";
};